/* ── Paranoise turntable bridge ───────────────────────────────────────
   Sends every tracklist play button to the 3D deck instead of the old slab
   player. paranoise-player.js is left running: it still renders the tracklist
   and resolves the preview URLs. We intercept in the CAPTURE phase so its own
   delegated click handler never fires — one audio source, and no next button:
   a shopper plays a track by clicking that track's own button.

   The player URL comes from window.PN_TT_ASSETS (set by the Liquid section) so
   it carries Shopify's ?v= hash; a bare relative import would pin a stale copy.
*/
let deck = null, loading = null;
function player() {
  if (deck) return Promise.resolve(deck);
  if (!loading) {
    const A = window.PN_TT_ASSETS || {};
    const url = A.player || new URL('./pn-turntable.js', import.meta.url).href;
    loading = import(url).then(m => (deck = m.PNTurntable));
  }
  return loading;
}
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.pn-track-trigger');
  if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
  const url = btn.dataset.url;
  if (!url) return;
  e.preventDefault();
  e.stopPropagation();                 // keep the old player out of it
  const side  = (btn.dataset.side  || '').trim();
  const title = (btn.dataset.title || btn.dataset.record || '').trim();
  player().then(P => P.open({
    url,
    title: side ? side + ' — ' + title : title,
    subtitle: [btn.dataset.artist, btn.dataset.record].filter(Boolean).join(' — '),
    artwork: window.PN_PRODUCT_ARTWORK || null,
    rpm: +(btn.dataset.rpm || 0) || 33.333,
  }));
}, true);                              // <- capture
